<template>
  <div v-if="textToShow" style="word-wrap: break-word">
    <v-icon>mdi-information-variant</v-icon><span v-html="text"></span>
  </div>
</template>

<script>

export default {
  name: 'custom-text',
  props: ['msg', 'customValue'],
  computed: {
    textToShow () {
      return this.$i18n.keyExists(this.msg)
    },
    text () {
      if (this.textToShow) {
        let x = this.$t(this.msg).join(' ')
        let key = this.$t(`student.values`)
        for (let v in key) {
          let y = '{{' + key[v] + '}}'
          if (x.includes(y)) {
            x = x.toString().replace(y, this.customValue.student[key[v]])
          }
        }
        return x
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/help/CustomText.vue